interface CasinoCardSkeletonProps {
  count?: number;
  className?: string;
}

export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div
      className={`relative aspect-square overflow-hidden rounded-lg bg-[#e6e8e9] shadow-sm ${className}`}
    >
      <div
        className="absolute inset-0 -translate-x-full animate-shimmer
          bg-gradient-to-r from-transparent via-[color-mix(in_srgb,var(--primary)_35%,white)] to-transparent"
      />
    </div>
  );
}

export default function CasinoCardSkeleton({ count = 16, className }: CasinoCardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} className={className} />
      ))}
    </>
  );
}
